import api from "../api";

export const sendMessageToAdmin = async (name, email, message) => {
    return api.post("/contact", {name, email, message});
};
